import React from "react";
import styles from "./Button.module.scss";
import classNames from "classnames";
import spinner from "../../assets/images/spinner.gif";

const Button = ({ title, onClick, className, style, disabled, loading }) => {
  return (
    <button
      disabled={disabled}
      style={style}
      className={classNames(
        className,
        styles.buttonContainer,
        disabled && styles.disabled
      )}
      onClick={onClick}
    >
      {loading ? (
        <img src={spinner} alt="loading-spinner" className={styles.spinner} />
      ) : (
        title
      )}
    </button>
  );
};

export default Button;
